import apiCall from "./apiCall";

const getListInspectionFee = async (param: any) => {
    const query = `?search=${param.search}&status=${param.status}&type=${param.type}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/InspectionFee/GetAllInspectorFees${query}`;
    return apiCall('get', URL);
};

const getInspectionFeeById = async (id: string) => {
    const URL = `/InspectionFee/GetInspectionFeeById/${id}`;
    return apiCall('get', URL);
};

const getInspectorFees = async (param: string) => {
    const URL = `/InspectionFee/GetDataInspectorFees?type=${param}`;
    return apiCall('get', URL);
};

const putInspectionFee = async (data: any) => {
    const URL = '/InspectionFee/Update';
    return apiCall('post', URL, data);
};

const postInspectionFee = async (data: any) => {
    const URL = '/InspectionFee/Create';
    return apiCall('post', URL, data);
};

const deleteInspectionFee = async (obj: any) => {
    const URL = '/InspectionFee/Delete';
    return apiCall('post', URL, obj);
};

export {
    deleteInspectionFee,
    postInspectionFee,
    putInspectionFee,
    getInspectionFeeById,
    getInspectorFees,
    getListInspectionFee
};
